import { render } from "./HeadingBreadcrumb.vue?vue&type=template&id=b496aaf2&scoped=true"
import script from "./HeadingBreadcrumb.vue?vue&type=script&lang=js"
export * from "./HeadingBreadcrumb.vue?vue&type=script&lang=js"

import "./HeadingBreadcrumb.vue?vue&type=style&index=0&id=b496aaf2&lang=css&scoped=true"

import exportComponent from "D:\\Mindscan\\online-quiz-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b496aaf2"]])

export default __exports__